function loadScriptIfNotLoaded(src, callback) {
  // Check if the script is already in the DOM
  const existingScript = document.querySelector(`script[src="${src}"]`);

  if (!existingScript) {
    // If the script is not found, create a new one
    const script = document.createElement("script");
    script.src = src;
    script.async = true;

    // Optional: Run a callback function after the script is loaded
    script.onload = () => {
      console.log(`${src} loaded successfully`);
      if (callback) callback();
    };

    script.onerror = () => {
      console.error(`Error loading script: ${src}`);
    };

    // Append the script to the document
    document.head.appendChild(script);
  } else {
    // Script already exists
    if (callback) callback();
  }
}
